// sort-imports-ignore
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';

// Fonts
import '@fontsource-variable/inter';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';

import '@/uikit/styles/main.scss';
const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
